import React from 'react';
import { getMediaUrl } from '../api';

const SettingsPage = ({
  categories,
  subCategories,
  categoryForm,
  setCategoryForm,
  subCategoryForm,
  setSubCategoryForm,
  addCategorySetting,
  addSubCategorySetting,
  settingsMessage,
}) => {
  return (
    <div className="card">
      <h3>Settings: Categories</h3>

      <div className="grid">
        <div>
          <label>Category Name</label>
          <input
            value={categoryForm.name}
            onChange={(e) => setCategoryForm({ ...categoryForm, name: e.target.value })}
            placeholder="e.g. Men"
          />
        </div>
        <div>
          <label>Category Image</label>
          <input
            type="file"
            accept="image/*"
            onChange={(e) =>
              setCategoryForm({ ...categoryForm, image: e.target.files?.[0] || null })
            }
          />
        </div>
      </div>
      <button onClick={addCategorySetting}>Add Category</button>

      <hr style={{ margin: '20px 0' }} />

      <h3>Settings: Sub Categories</h3>
      <div className="grid">
        <div>
          <label>Select Category</label>
          <select
            value={subCategoryForm.category_id}
            onChange={(e) => setSubCategoryForm({ ...subCategoryForm, category_id: e.target.value })}
          >
            <option value="">Choose Category</option>
            {(categories || []).map((c) => (
              <option key={c._id} value={c._id}>
                {c.name}
              </option>
            ))}
          </select>
        </div>
        <div>
          <label>Sub Category Name</label>
          <input
            value={subCategoryForm.name}
            onChange={(e) => setSubCategoryForm({ ...subCategoryForm, name: e.target.value })}
            placeholder="e.g. Shirts"
          />
        </div>
        <div>
          <label>Sub Category Image</label>
          <input
            type="file"
            accept="image/*"
            onChange={(e) =>
              setSubCategoryForm({ ...subCategoryForm, image: e.target.files?.[0] || null })
            }
          />
        </div>
      </div>
      <button onClick={addSubCategorySetting}>Add Sub Category</button>

      {settingsMessage ? <div className="muted" style={{ marginTop: 12 }}>{settingsMessage}</div> : null}

      <hr style={{ margin: '20px 0' }} />

      <h4>Existing Categories</h4>
      <div className="table-wrap">
        <table className="table">
          <thead>
            <tr>
              <th>Image</th>
              <th>Name</th>
            </tr>
          </thead>
          <tbody>
            {(categories || []).map((c) => (
              <tr key={c._id}>
                <td>
                  {c.image ? (
                    <img src={getMediaUrl(c.image)} alt={c.name} style={{ width: 40, height: 40, objectFit: 'cover', borderRadius: 8 }} />
                  ) : (
                    '-'
                  )}
                </td>
                <td>{c.name}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <h4 style={{ marginTop: 18 }}>Existing Sub Categories</h4>
      <div className="table-wrap">
        <table className="table">
          <thead>
            <tr>
              <th>Image</th>
              <th>Sub Category</th>
              <th>Category</th>
            </tr>
          </thead>
          <tbody>
            {(subCategories || []).map((s) => (
              <tr key={s._id}>
                <td>
                  {s.image ? (
                    <img src={getMediaUrl(s.image)} alt={s.name} style={{ width: 40, height: 40, objectFit: 'cover', borderRadius: 8 }} />
                  ) : (
                    '-'
                  )}
                </td>
                <td>{s.name}</td>
                <td>{s.category_name || '-'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SettingsPage;
